// extracted by mini-css-extract-plugin
export default {"menu":"capacities_menu__E1K0U","header":"capacities_header__XRvhO","table":"capacities_table__qgLp2"};